export function padZ(n: number): string {
  return String(n).padStart(2, "0");
}

export function fmtS(s: string | null | undefined): string {
  if (!s || !s.includes("-")) return s || "";
  try {
    const parts = s.split("-");
    if (parts.length !== 3) return s;
    const [, m, d] = parts;
    return `${d}/${m}`;
  } catch {
    return s;
  }
}

export function fmtF(s: string | null | undefined): string {
  if (!s || !s.includes("-")) return s || "";
  try {
    const parts = s.split("-");
    if (parts.length !== 3) return s;
    const [y, m, d] = parts;
    return `${d}/${m}/${y}`;
  } catch {
    return s;
  }
}

export function dSt(s: string | null | undefined): "late" | "today" | "soon" | "" {
  if (!s || !s.includes("-")) return "";
  const target = new Date(s + "T00:00:00").getTime();
  if (Number.isNaN(target)) return "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.floor((target - today.getTime()) / 86_400_000);
  if (diff < 0) return "late";
  if (diff === 0) return "today";
  if (diff <= 3) return "soon";
  return "";
}

export function parseDtData(s: string | null | undefined): Date | null {
  if (!s) return null;
  const p = s.split("/");
  if (p.length < 2) return null;
  const d = parseInt(p[0]!, 10);
  const m = parseInt(p[1]!, 10) - 1;
  const yStr = p[2];
  const y = yStr ? parseInt(yStr, 10) + (yStr.length === 2 ? 2000 : 0) : new Date().getFullYear();
  if (!Number.isFinite(d) || !Number.isFinite(m) || !Number.isFinite(y)) return null;
  const dt = new Date(y, m, d);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function todayISO(): string {
  return new Date().toISOString().split("T")[0]!;
}

export function formatHistoryDate(d: Date = new Date()): string {
  return `${padZ(d.getDate())}/${padZ(d.getMonth() + 1)}/${d.getFullYear()} ${padZ(d.getHours())}:${padZ(d.getMinutes())}`;
}
